import React from 'react';
import { useTranslation } from 'react-i18next';
import Svg from 'src/components/Svg';
import s from './CapboxDigitalLearning.styles';

const CapboxDigitalLearning = ({disableMyCourse}) => {
    const { t } = useTranslation();

    const navigateToEiqLearn = () => {
        if (!SSO_HOST || !EIQ_LEARN_HOST ) {
            return;
        }
       
        window.location.replace(`https://${SSO_HOST}/go?target_url=${EIQ_LEARN_HOST}&requester=eiqassess&destination=eiqlearning`);
      };

    return (
            <s.Half enableBorder digitalLearning>
                <s.CapboxDigitalLearningWrapper>
                    <s.CapboxDigitalLearningTitle>
                        {t('CAP_DIGITAL_LEARNING')}
                    </s.CapboxDigitalLearningTitle>
                    <s.CapboxDigitalLearningLogo name="eiq-learn-logo"></s.CapboxDigitalLearningLogo>
                    <s.CapboxDigitalLearningDescription>
                        {t('CAP_DIGITAL_LEARNING_DESCRIPTION')}
                    </s.CapboxDigitalLearningDescription>
                    <s.CapboxDigitalLearningMyCourses className={disableMyCourse ? 'disableLink' : ''} onClick={navigateToEiqLearn}>
                        {t('CAP_DIGITAL_LEARNING_MY_COURSES')}
                    </s.CapboxDigitalLearningMyCourses>
                </s.CapboxDigitalLearningWrapper>                
            </s.Half>
    )
};

export default React.memo(CapboxDigitalLearning);
